import ColorPicker from './ColorPicker';
import { OptionSelector } from './OptionSelector';
import { SelectableImage } from './SelectableImage';

import icClarinSelector from '@/assets/sponsors/ic_clarin-selector.jpg';
import icNeckPolo from '@/assets/sponsors/ic_neck-polo-selector.png';
import icNeckRounded from '@/assets/sponsors/ic_neck-rounded-selector.png';
import icNeckVe from '@/assets/sponsors/ic_neck-ve-selector.png';
import icNoneSelector from '@/assets/sponsors/ic_none-selector.jpg';
import icOleSelector from '@/assets/sponsors/ic_ole-selector.jpg';
import icTnSelector from '@/assets/sponsors/ic_tn-selector.jpg';
import { Divider } from '@/components';
import { Svg } from '@/types/editProfile';

type CustomizationProps = {
  handleCustomizationValuesChange: (values: Svg) => void;
  customizationValues?: Svg;
};

export const TshirtPanelCustomization = ({
  handleCustomizationValuesChange,
  customizationValues,
}: CustomizationProps) => {
  const sponsors = [
    { src: icOleSelector, alt: 'Olé', param: '1' },
    { src: icClarinSelector, alt: 'Clarín', param: '4' },
    { src: icTnSelector, alt: 'TN Noticias', param: '3' },
    { src: icNoneSelector, alt: 'Sin sponsor', param: '99' },
  ];

  const necks = [
    { src: icNeckRounded, alt: 'Cuello redondo', param: '1' },
    { src: icNeckVe, alt: 'Cuello V', param: '2' },
    { src: icNeckPolo, alt: 'Cuello Polo', param: '3' },
  ];

  return (
    <div className="lg:w-[329px] w-screen max-w-xs  mx-auto mt-8 lg:mt-2 lg:p-0 lg:px-4 lg:bg-white rounded-lg shadow-sm ">
      <div className="px-4 lg:px-0 py-5 lg:pt-0 bg-white lg:bg-transparent rounded-lg">
        <p className="font-bold lg:mt-7">Modelo</p>
        <div className="flex items-center justify-between mt-3">
          {necks.map((neck) => {
            return (
              <SelectableImage
                key={neck.alt}
                alt={neck.alt}
                className="bg-[#929292] w-[80px] h-[80px] overflow-hidden"
                selected={
                  (customizationValues?.camiseta?.param1 || '1') === neck.param
                }
                src={neck.src}
                onClick={() => {
                  handleCustomizationValuesChange({
                    ...customizationValues,
                    camiseta: {
                      ...customizationValues?.camiseta,
                      param1: neck.param,
                    },
                  });
                }}
              />
            );
          })}
        </div>
      </div>
      <Divider className="hidden lg:block" type="horizontal" />
      <div className="px-4 lg:px-0 py-5 lg:pt-0 bg-white lg:bg-transparent rounded-lg mt-4">
        <OptionSelector
          handleCustomizationValuesChange={handleCustomizationValuesChange}
          initialOption={customizationValues?.camiseta?.param2 ?? null}
          label="Trama"
          type={'tshirtPattern'}
          values={customizationValues}
        />
      </div>
      <Divider className="hidden lg:block" type="horizontal" />
      <div className="bg-white lg:bg-transparent rounded-lg mt-4 lg:mt-0">
        <ColorPicker
          handleCustomizationValuesChange={handleCustomizationValuesChange}
          initialColor={`#${customizationValues?.camiseta?.param3}`}
          label="Color de la Camiseta"
          type={'tshirtBackground'}
          values={customizationValues}
        />
      </div>
      <Divider className="hidden lg:block" type="horizontal" />
      <div className="bg-white lg:bg-transparent rounded-lg mt-4 lg:mt-0">
        <ColorPicker
          handleCustomizationValuesChange={handleCustomizationValuesChange}
          initialColor={`#${customizationValues?.camiseta?.param4}`}
          label="Color de la Trama"
          type={'tshirtColorPattern'}
          values={customizationValues}
        />
      </div>
      <Divider className="hidden lg:block" type="horizontal" />
      <div className="px-4 lg:px-0 py-5 bg-white lg:bg-transparent rounded-lg mt-4 lg:mt-0">
        <p className="font-bold">Sponsor</p>
        <div className="flex items-center justify-between mt-3">
          {sponsors.map((sponsor) => {
            return (
              <SelectableImage
                key={sponsor.alt}
                alt={sponsor.alt}
                className="overflow-hidden"
                selected={
                  customizationValues?.camiseta?.param5 === sponsor.param
                }
                src={sponsor.src}
                onClick={() => {
                  handleCustomizationValuesChange({
                    ...customizationValues,
                    camiseta: {
                      ...customizationValues?.camiseta,
                      param5: sponsor.param,
                    },
                  });
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
